import { FunctionComponent } from 'preact';

import { Typography } from '../Typography/Typography';
import { useTranslation } from '../../../../utils/useTranslation';
import ns from '../../translations';
import { ReportButton } from '../../components/ReportButton/ReportButton';
import { NextUpButton } from '../buttons/NextUpButton';
import { CaptionsButton } from '../../components/buttons/CaptionsButton';
import { QualityButton } from '../buttons/QualityButton';
import { useViewportType } from '../../hooks/useViewportType';

type SettingsProps = {
  displayNextUp?: boolean;
  canReportIssue?: boolean;
  hasCaptions?: boolean;
  handleNextUpButtonClick?: () => void;
  handleCaptionsButtonClick?: () => void;
  handleQualityButtonClick?: () => void;
  canDisplayQualities?: boolean;
};

export const Settings: FunctionComponent<SettingsProps> = ({
  displayNextUp,
  canReportIssue,
  hasCaptions,
  handleNextUpButtonClick,
  handleCaptionsButtonClick,
  handleQualityButtonClick,
  canDisplayQualities,
}) => {
  const { t } = useTranslation(ns);

  const { isMobile } = useViewportType();
  const size = isMobile ? 'medium' : 'large';

  return (
    <div>
      <ul className="vgp-settings-list">
        {displayNextUp && (
          <li
            className="vgp-settings-list-item"
            onClick={handleNextUpButtonClick}
          >
            <Typography variant="label" size={size} color="primary">
              {t('Related videos')}
            </Typography>
            <NextUpButton color="transparent-primary" />
          </li>
        )}
        {hasCaptions && (
          <li
            className="vgp-settings-list-item"
            onClick={handleCaptionsButtonClick}
          >
            <Typography variant="label" size={size} color="primary">
              {t('Captions')}
            </Typography>
            <CaptionsButton color="transparent-primary" />
          </li>
        )}
        {canReportIssue && (
          <li>
            <ReportButton className="vgp-settings-list-item" fontSize={size} />
          </li>
        )}
        {canDisplayQualities && (
          <li
            className="vgp-settings-list-item"
            onClick={handleQualityButtonClick}
          >
            <Typography variant="label" size={size} color="primary">
              {t('Quality')}
            </Typography>
            <QualityButton color="transparent-primary" />
          </li>
        )}
      </ul>
    </div>
  );
};
